var _rect, _g, _circle, _path, _text, _rect2, _circle2, _text2, _text3, _rect3, _rect4, _rect5, _rect6, _circle3, _text4, _text5, _rect7, _rect8, _rect9, _rect0, _circle4, _text6, _text7, _rect1, _rect10, _rect11, _rect12, _circle5, _text8, _text9, _rect13, _rect14, _rect15, _rect16, _circle6, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentOperationalFrictionFragmentedWorkflowMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 820,
    viewBox: "0 0 620 820",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Custom development mobile fragmented workflow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 596,
    height: 796,
    rx: 34,
    fill: "#07152A",
    stroke: "#294766",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6EB8F8",
    strokeOpacity: 0.42,
    strokeWidth: 2,
    strokeDasharray: "7 10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 150L310 355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 150L310 355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 525L310 355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 525L310 355"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 355,
    r: 70,
    fill: "#0B1D35",
    stroke: "#FF2775",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M287 332l46 46M333 332l-46 46",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 454,
    fill: "#FF91BA",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12,
    textAnchor: "middle",
    fontWeight: 820,
    letterSpacing: 1.5
  }, "PROCESS GAP")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 70,
    width: 238,
    height: 160,
    rx: 21,
    fill: "#0B2341",
    stroke: "#087CFF",
    strokeOpacity: 0.72
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 98,
    r: 6,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 103,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "INBOX")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 135,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Requests and approvals")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 161,
    width: 196,
    height: 7,
    rx: 3.5,
    fill: "#087CFF",
    opacity: 0.65
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 183,
    width: 178,
    height: 7,
    rx: 3.5,
    fill: "#087CFF",
    opacity: 0.53
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 205,
    width: 160,
    height: 7,
    rx: 3.5,
    fill: "#087CFF",
    opacity: 0.41000000000000003
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 70,
    width: 238,
    height: 160,
    rx: 21,
    fill: "#0B2341",
    stroke: "#30D6A1",
    strokeOpacity: 0.72
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 98,
    r: 6,
    fill: "#30D6A1"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 103,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "SPREADSHEET")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 357,
    y: 135,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Duplicate capture")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 161,
    width: 196,
    height: 7,
    rx: 3.5,
    fill: "#30D6A1",
    opacity: 0.65
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 183,
    width: 178,
    height: 7,
    rx: 3.5,
    fill: "#30D6A1",
    opacity: 0.53
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 205,
    width: 160,
    height: 7,
    rx: 3.5,
    fill: "#30D6A1",
    opacity: 0.41000000000000003
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 445,
    width: 238,
    height: 160,
    rx: 21,
    fill: "#0B2341",
    stroke: "#FF2775",
    strokeOpacity: 0.72
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 473,
    r: 6,
    fill: "#FF2775"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 478,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "CHAT THREAD")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 510,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Unstructured decisions")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 536,
    width: 196,
    height: 7,
    rx: 3.5,
    fill: "#FF2775",
    opacity: 0.65
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 558,
    width: 178,
    height: 7,
    rx: 3.5,
    fill: "#FF2775",
    opacity: 0.53
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 580,
    width: 160,
    height: 7,
    rx: 3.5,
    fill: "#FF2775",
    opacity: 0.41000000000000003
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 445,
    width: 238,
    height: 160,
    rx: 21,
    fill: "#0B2341",
    stroke: "#F5B642",
    strokeOpacity: 0.72
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 361,
    cy: 473,
    r: 6,
    fill: "#F5B642"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 478,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 830
  }, "LEGACY PLATFORM")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 357,
    y: 510,
    fill: "#9FB3C9",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 620
  }, "Delayed reporting")), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 536,
    width: 196,
    height: 7,
    rx: 3.5,
    fill: "#F5B642",
    opacity: 0.65
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 558,
    width: 178,
    height: 7,
    rx: 3.5,
    fill: "#F5B642",
    opacity: 0.53
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 357,
    y: 580,
    width: 160,
    height: 7,
    rx: 3.5,
    fill: "#F5B642",
    opacity: 0.41000000000000003
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 710,
    width: 380,
    height: 54,
    rx: 15,
    fill: "#101E33",
    stroke: "#344E6A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 737,
    r: 5,
    fill: "#F5B642"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 742,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 800
  }, "MANUAL RECONCILIATION REQUIRED")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentOperationalFrictionFragmentedWorkflowMobile);
export default __webpack_public_path__ + "static/media/custom-development-operational-friction-fragmented-workflow-mobile.2421c092fe30210845ee781343e2c1c1.svg";
export { ForwardRef as ReactComponent };